import React, { createContext, useEffect, useState } from 'react';
import axios from 'axios';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
    const [therapistId, setTherapistId] = useState(null);
    const [username, setUsername] = useState(null);
    const [loadingSession, setLoadingSession] = useState(true);
    
    const checkSession = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/session?role=therapist`, {
                withCredentials: true
            });
            
            if (response.data?.userId && response.data.role === 'caregiver') {
                setTherapistId(response.data.userId);
                setUsername(response.data.username);
            } else {
                setTherapistId(null);
                setUsername(null);
            }
        } catch (err) {
            console.warn("Caregiver session check failed:", err);
            setTherapistId(null);
            setUsername(null);
        } finally {
            setLoadingSession(false);
        }
    };
    
    useEffect(() => {
        checkSession().then(() => {});
    }, []);
    
    const logout = () => {
        setTherapistId(null);
        setUsername(null);
    };
    
    return (
        <AppContext.Provider value={{
            userId: therapistId,
            username,
            logout,
            loadingSession,
            checkSession
        }}>
            {children}
        </AppContext.Provider>
    );
};
